import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LeftNavbarService {
  private collapsed: boolean = false;

  toggle(): void {
    this.collapsed = !this.collapsed;
  }

  isCollapsed(): boolean {
    return this.collapsed;
  }
}
